import { filter, startsWith } from 'lodash';
import { MODELS } from '../../../constants/admin/settings';
import { imageFixRTE } from '../../../lib/dom.utils';
import { createSelector } from 'reselect';
import { dataSelector } from '../tables';

export const ARTIST_SIGNED_CONTRACT = 'ARTIST_SIGNED_CONTRACT';
export const ARTIST_UPDATE_CONTRACT = 'ARTIST_UPDATE_CONTRACT';
export const ARTIST_NEW_CONTRACT = 'ARTIST_NEW_CONTRACT';
export const ARTIST_REMINDER_CONTRACT = 'ARTIST_REMINDER_CONTRACT';

export const ARTIST_SIGNED_PERF_CONTRACT = 'ARTIST_SIGNED_PERF_CONTRACT';
export const ARTIST_UPDATE_PERF_CONTRACT = 'ARTIST_UPDATE_PERF_CONTRACT';
export const ARTIST_NEW_PERF_CONTRACT = 'ARTIST_NEW_PERF_CONTRACT';
export const ARTIST_REMINDER_PERF_CONTRACT = 'ARTIST_REMINDER_PERF_CONTRACT';

export const EMAIL_TYPES_TEXT = {
    [ARTIST_NEW_CONTRACT]: 'New clearance contract',
    [ARTIST_UPDATE_CONTRACT]: 'Update clearance contract',
    [ARTIST_SIGNED_CONTRACT]: 'Signed clearance contract',
    [ARTIST_REMINDER_CONTRACT]: 'Reminder clearance contract',
    [ARTIST_NEW_PERF_CONTRACT]: 'New performance contract',
    [ARTIST_UPDATE_PERF_CONTRACT]: 'Update performance contract',
    [ARTIST_SIGNED_PERF_CONTRACT]: 'Signed performance contract',
    [ARTIST_REMINDER_PERF_CONTRACT]: 'Reminder performance contract',
    ALL_NEW_PERMISSIONS: 'New permissions',
    PARTNER_UPDATE_LINEUP: 'Update lineup'
};

export const eventSenderOptionsSelector = createSelector(dataSelector, data => {
    return filter(data || [], sender => sender.verified).map(x => ({
        value: JSON.stringify({ name: x.name, email: x.email }),
        label: `${x.name} <${x.email}>`
    }));
});

export function typeToHumanReadable(type) {
    return EMAIL_TYPES_TEXT[type] || type;
}

export function receiverFromType(type) {
    return startsWith(type, MODELS.ARTIST.toUpperCase())
        ? 'Artists'
        : startsWith(type, MODELS.PARTNER.toUpperCase())
          ? 'Mediapartners'
          : 'All';
}

export function apiDataToState(content) {
    return content
        .replace(/\[RECIPIENTS\]/g, '<rcp contenteditable="false">RECIPIENTS</rcp>')
        .replace(/\[EVENT_NAME\]/g, '<ev contenteditable="false">EVENT NAME</ev>')
        .replace(/\[MEDIA_PARTNER\]/g, '<prt contenteditable="false">PARTNER NAME</prt>')
        .replace(/\[ARTIST\]/g, '<art contenteditable="false">ARTIST NAME</art>')
        .replace(/\[MESSAGE\]/g, '<msg contenteditable="false">UPDATE MESSAGE</msg>')
        .replace(/\[PIN_CODE\]/g, '<pin contenteditable="false">PIN CODE</pin>')
        .replace(/\[CONTENT\]/g, '<cnt contenteditable="false">CONTRACT CONTENT</cnt>');
}
export function stateToApiData(content) {
    const regexRecipients = /<rcp .*?>.*?<\/rcp>/g;
    const regexEvent = /<ev .*?>.*?<\/ev>/g;
    const regexArtist = /<art .*?>.*?<\/art>/g;
    const regexPartner = /<prt .*?>.*?<\/prt>/g;
    const regexMessage = /<msg .*?>.*?<\/msg>/g;
    const regexContent = /<cnt .*?>.*?<\/cnt>/g;
    const regexPinCode = /<pin .*?>.*?<\/pin>/g;
    return imageFixRTE(
        content
            .replace(regexRecipients, '[RECIPIENTS]')
            .replace(regexEvent, '[EVENT_NAME]')
            .replace(regexPartner, '[MEDIA_PARTNER]')
            .replace(regexArtist, '[ARTIST]')
            .replace(regexMessage, '[MESSAGE]')
            .replace(regexContent, '[CONTENT]')
            .replace(regexPinCode, '[PIN_CODE]')
    );
}
